export default "__VITE_ASSET__DM_3d9CT__"